export const RegistrationAction = {
    SET_LANGUAGE: "set_lamguage",
    SEND_OTP: "send_otp",
    VALIDATE_OTP: "validate_otp"
}